import { Layout } from '../components/Layout'
import { MentalHealth } from '../components/mental-health/MentalHealth'

const Anxiety = () => {
  return (
    <Layout>
      <MentalHealth condition="anxiety" />
    </Layout>
  )
}

export default Anxiety
